"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var OfferUpperSection_module_scss_1 = __importDefault(require("./OfferUpperSection.module.scss"));
var SocialLoginPanel_1 = __importDefault(require("./SocialLoginPanel"));
var CAROUSEL_INTERVAL_MS = 5000;
var SWIPE_THRESHOLD_PX = 50;
var getSlidesPerView = function (viewportWidth) {
    if (viewportWidth <= 640) {
        return 1;
    }
    if (viewportWidth <= 1024) {
        return 2;
    }
    return 4;
};
var OfferUpperSection = function (_a) {
    var slides = _a.slides;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(0), activeIndex = _b[0], setActiveIndex = _b[1];
    var _c = (0, react_1.useState)(function () {
        return typeof window === "undefined" ? 4 : getSlidesPerView(window.innerWidth);
    }), slidesPerView = _c[0], setSlidesPerView = _c[1];
    var swipeStartX = (0, react_1.useRef)(null);
    var effectiveSlidesPerView = Math.max(1, Math.min(slidesPerView, slides.length || 1));
    var maxStartIndex = Math.max(slides.length - effectiveSlidesPerView, 0);
    (0, react_1.useEffect)(function () {
        setActiveIndex(0);
    }, [slides.length]);
    (0, react_1.useEffect)(function () {
        if (typeof window === "undefined") {
            return undefined;
        }
        var updateSlidesPerView = function () {
            setSlidesPerView(getSlidesPerView(window.innerWidth));
        };
        updateSlidesPerView();
        window.addEventListener("resize", updateSlidesPerView);
        return function () { return window.removeEventListener("resize", updateSlidesPerView); };
    }, []);
    (0, react_1.useEffect)(function () {
        setActiveIndex(function (currentIndex) { return Math.min(currentIndex, maxStartIndex); });
    }, [maxStartIndex]);
    var handlePointerDown = function (event) {
        var _a, _b;
        swipeStartX.current = event.clientX;
        (_b = (_a = event.currentTarget).setPointerCapture) === null || _b === void 0 ? void 0 : _b.call(_a, event.pointerId);
    };
    var handlePointerUp = function (event) {
        if (swipeStartX.current === null ||
            slides.length <= effectiveSlidesPerView) {
            return;
        }
        var swipeDistance = event.clientX - swipeStartX.current;
        swipeStartX.current = null;
        if (Math.abs(swipeDistance) < SWIPE_THRESHOLD_PX) {
            return;
        }
        setActiveIndex(function (currentIndex) {
            if (swipeDistance < 0) {
                return currentIndex >= maxStartIndex ? 0 : currentIndex + 1;
            }
            return currentIndex <= 0 ? maxStartIndex : currentIndex - 1;
        });
    };
    (0, react_1.useEffect)(function () {
        if (slides.length <= effectiveSlidesPerView) {
            return undefined;
        }
        var intervalId = window.setInterval(function () {
            setActiveIndex(function (currentIndex) {
                return currentIndex >= maxStartIndex ? 0 : currentIndex + 1;
            });
        }, CAROUSEL_INTERVAL_MS);
        return function () { return window.clearInterval(intervalId); };
    }, [effectiveSlidesPerView, maxStartIndex, slides.length]);
    return ((0, jsx_runtime_1.jsxs)("header", { className: OfferUpperSection_module_scss_1.default.upperShell, children: [(0, jsx_runtime_1.jsx)("div", { className: OfferUpperSection_module_scss_1.default.topBar, children: (0, jsx_runtime_1.jsx)("div", { className: OfferUpperSection_module_scss_1.default.topContent, children: (0, jsx_runtime_1.jsx)("img", { className: OfferUpperSection_module_scss_1.default.headerImage, src: "https://storage.googleapis.com/the-money-printer/header.jpg", alt: t("OFFER_UPPER_HEADER_ALT") }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: OfferUpperSection_module_scss_1.default.carouselRow, children: [(0, jsx_runtime_1.jsxs)("div", { className: OfferUpperSection_module_scss_1.default.carousel, children: [(0, jsx_runtime_1.jsx)("div", { className: OfferUpperSection_module_scss_1.default.heroCard, onPointerDown: handlePointerDown, onPointerUp: handlePointerUp, style: {
                                    "--slides-per-view": effectiveSlidesPerView
                                }, children: (0, jsx_runtime_1.jsx)("div", { className: OfferUpperSection_module_scss_1.default.carouselTrack, style: {
                                        transform: "translateX(-".concat(activeIndex * (100 / effectiveSlidesPerView), "%)")
                                    }, children: slides.map(function (slide, index) { return ((0, jsx_runtime_1.jsxs)("div", { className: OfferUpperSection_module_scss_1.default.carouselSlide, "aria-hidden": index < activeIndex ||
                                            index >=
                                                activeIndex + effectiveSlidesPerView, children: [(0, jsx_runtime_1.jsx)("img", { className: OfferUpperSection_module_scss_1.default.heroImage, src: slide.imageUrl, alt: "", "aria-hidden": "true", draggable: false }), slide.clickUrl && ((0, jsx_runtime_1.jsx)("a", { className: OfferUpperSection_module_scss_1.default.carouselButton, href: slide.clickUrl, tabIndex: index >= activeIndex &&
                                                    index <
                                                        activeIndex +
                                                            effectiveSlidesPerView
                                                    ? 0
                                                    : -1, children: slide.buttonText }))] }, "".concat(slide.imageUrl, "-").concat(index))); }) }) }), maxStartIndex > 0 && ((0, jsx_runtime_1.jsx)("div", { className: OfferUpperSection_module_scss_1.default.carouselDots, "aria-label": t("OFFER_UPPER_CAROUSEL_NAV_ARIA"), children: Array.from({ length: maxStartIndex + 1 }).map(function (_, index) { return ((0, jsx_runtime_1.jsx)("button", { className: "".concat(OfferUpperSection_module_scss_1.default.carouselDot, " ").concat(index === activeIndex
                                        ? OfferUpperSection_module_scss_1.default.active
                                        : ""), type: "button", "aria-label": t("OFFER_UPPER_SHOW_SLIDE_ARIA", {
                                        index: index + 1
                                    }), "aria-current": index === activeIndex
                                        ? "true"
                                        : undefined, onClick: function () { return setActiveIndex(index); } }, "dot-".concat(index))); }) }))] }), (0, jsx_runtime_1.jsx)("div", { className: OfferUpperSection_module_scss_1.default.topIcons, children: (0, jsx_runtime_1.jsx)(SocialLoginPanel_1.default, {}) })] })] }));
};
exports.default = OfferUpperSection;
